import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggle', 'row']
  static values = {
    class: String
  }

  update () {
    const shouldShow = this.toggleTarget.checked
    this.rowTargets.forEach(row => {
      row.classList.toggle(this.classValue, !shouldShow)
    })
  }
}
